'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IntlProviderContainer = require('./Container components/IntlProviderContainer/IntlProviderContainer');

var _MuiThemeProviderContainer = require('./Container components/MuiThemeProviderContainer/MuiThemeProviderContainer');

var _LoadingContainer = require('./Container components/LoadingContainer/LoadingContainer');

var _SnackBarContainer = require('./Container components/SnackBarContainer/SnackBarContainer');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reactTapEventPlugin = require('react-tap-event-plugin');

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* import {
  AppCacheProviderContainer,
} from './Container components/AppCacheProviderContainer/AppCacheProviderContainer'; */


(0, _reactTapEventPlugin2.default)();

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          routes = _props.routes;

      var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
      return (
        // TODO : cercare informazioni su 'reselect'
        // TODO : detect javascript enabled
        // TODO : save state in locastorage (for Example)
        // TODO : inviare lo state al crash
        // TODO : componente console log che invia al server con un interval
        // <AppCacheProviderContainer/>
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: store },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _MuiThemeProviderContainer.MuiThemeProviderContainer,
              null,
              _react2.default.createElement(
                _IntlProviderContainer.IntlProviderContainer,
                null,
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_LoadingContainer.LoadingContainer, null),
                  _react2.default.createElement(_SnackBarContainer.SnackBarContainer, null),
                  _react2.default.createElement(_reactRouter.Router, { history: history, routes: routes })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  store: _react2.default.PropTypes.object.isRequired,
  routes: _react2.default.PropTypes.array.isRequired
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/App.js
 ** module id = 464
 ** module chunks = 0
 **/